import { Helper } from '@/mixin/helper'
import store from '@/state/store'
const hasAccessAll = store.getters['identity/hasAccessAll']

export default [
  {
    path: '/fleet-availability',
    name: 'Fleet Availability',
    meta: {
      authRequired: false,
      hasAccess: true,
      beforeResolve(_, routeFrom, next) {
        const hasTms = hasAccessAll(['tms:create', 'tms:read', 'tms:update', 'tms:delete'])
        const hasFti = hasAccessAll(['fleet-task-instant:create', 'fleet-task-instant:read', 'fleet-task-instant:update', 'fleet-task-instant:delete'])
        if (!hasTms && !hasFti) return next({ name: 'Liveview' })

        Helper.methods.userLogging('Access', _)
        next()
      },
    },
    component: () => import('@/router/views/fleet-availability'),
  },
]
